import { useState, useCallback } from 'react';
import type { ViewerItem } from '@rocco/components/photo-document-viewer';

interface UsePhotoDocumentViewerReturn {
    isOpen: boolean;
    items: ViewerItem[];
    openViewer: (items: ViewerItem[]) => void;
    closeViewer: () => void;
}

/**
 * Hook for managing photo/document viewer modal state
 * Provides functions to open the viewer with content
 */
export const usePhotoDocumentViewer = (): UsePhotoDocumentViewerReturn => {
    const [isOpen, setIsOpen] = useState(false);
    const [items, setItems] = useState<ViewerItem[]>([]);

    const openViewer = useCallback((newItems: ViewerItem[]) => {
        setItems(newItems);
        setIsOpen(true);
    }, []);

    const closeViewer = useCallback(() => {
        setIsOpen(false);
        setItems([]);
    }, []);

    return {
        isOpen,
        items,
        openViewer,
        closeViewer,
    };
};
